(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinical-studies"] && !Shopify.designMode) return;
  try {
    
  function closeAllClinicalModals() {
    document.querySelectorAll('[data-modal-panel]').forEach((panel) => panel.classList.remove('is-open'));
    document.querySelectorAll('[data-modal-backdrop]').forEach((backdrop) => (backdrop.hidden = true));
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-modal-trigger]');
    if (trigger) {
      const slug = trigger.dataset.modalTarget;
      const panel = document.querySelector('[data-modal-panel][data-modal-slug="' + slug + '"]');
      if (panel) {
        panel.classList.add('is-open');
        const backdrop = panel.parentElement.querySelector('[data-modal-backdrop]') || document.querySelector('[data-modal-backdrop]');
        if (backdrop) backdrop.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    if (event.target.closest('[data-modal-close]') || event.target.closest('[data-modal-backdrop]')) {
      closeAllClinicalModals();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllClinicalModals();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["difference-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-flip-toggle]');
    if (!button) return;

    const card = button.closest('[data-flip-card]');
    if (!card) return;

    const flipped = card.classList.toggle('is-flipped');
    const front = card.querySelector('.difference-card__face--front');
    const back = card.querySelector('.difference-card__face--back');
    if (front) front.setAttribute('aria-hidden', flipped ? 'true' : 'false');
    if (back) back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["difference-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-scroll-to-card]');
    if (!link) return;

    const slug = link.dataset.cardSlug;
    const target = document.querySelector('[data-difference-card="' + slug + '"]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["research-topics-content"] && !Shopify.designMode) return;
  try {
    
  function closeAllResearchTopicModals() {
    document.querySelectorAll('[data-modal-panel]').forEach((panel) => panel.classList.remove('is-open'));
    document.querySelectorAll('[data-modal-backdrop]').forEach((backdrop) => (backdrop.hidden = true));
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-modal-trigger]');
    if (trigger) {
      const slug = trigger.dataset.modalTarget;
      const panel = document.querySelector('[data-modal-panel][data-modal-slug="' + slug + '"]');
      if (panel) {
        panel.classList.add('is-open');
        const backdrop = panel.parentElement.querySelector('[data-modal-backdrop]') || document.querySelector('[data-modal-backdrop]');
        if (backdrop) backdrop.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    if (event.target.closest('[data-modal-close]') || event.target.closest('[data-modal-backdrop]')) {
      closeAllResearchTopicModals();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllResearchTopicModals();
  });

  } catch(e) { console.error(e); }
})();
})();
